import { createFileRoute } from "@tanstack/react-router";
import { Section, SectionHeading } from "@/components/site/Section";
import { ReviewPlatforms } from "@/components/site/ReviewsBlock";
import { FilteredReviews } from "@/components/site/ReviewFilters";
import { ReviewCta } from "@/components/site/ReviewCta";
import { CtaBand } from "@/components/site/CtaBand";
import { JsonLd } from "@/components/site/JsonLd";
import { localBusinessSchema, meta } from "@/lib/schema";
import { overviewKeywords } from "@/lib/localKeywords";
import { getReviewWidgets } from "@/lib/reviewSettings.functions";
import { EmbedHtml } from "@/components/site/EmbedHtml";

const title = "Reviews verhuisbedrijf: 4,9/5 uit 507 beoordelingen | Vakkundig";
const description =
  "Lees echte klantbeoordelingen van Vakkundig Verhuizingen & Transport: 4,9 gemiddeld uit 507 reviews op Google, Trustoo (9,9) en VerhuisOffertes (9,7). Ervaringen met verhuizen, opslag en transport.";

export const Route = createFileRoute("/reviews")({
  head: () => meta({
      title,
      description,
      path: "/reviews",
      image: "particulier",
      keywords: overviewKeywords(["verhuisbedrijf reviews", "beste verhuisbedrijf den haag", "ervaringen verhuisbedrijf"]),
    }),
  loader: () => getReviewWidgets().catch(() => ({ trustoo: "", google: "" })),
  component: ReviewsPage,
});

function ReviewsPage() {
  const widgets = Route.useLoaderData();
  return (
    <>
      <JsonLd data={localBusinessSchema} />

      <Section tone="navy">
        <SectionHeading
          as="h1"
          eyebrow="Reviews"
          title="Wat onze klanten écht van ons vinden"
          intro="Alle reviews hieronder zijn door klanten geplaatst op onafhankelijke platformen. Klik op een platform om ze bij de bron te lezen."
          inverted
        />
      </Section>

      <Section>
        <ReviewPlatforms />
        <div className="mt-10">
          <ReviewCta />
        </div>
        {widgets.google ? <div className="mt-12"><EmbedHtml html={widgets.google} /></div> : null}
        {widgets.trustoo ? <div className="mt-12"><EmbedHtml html={widgets.trustoo} /></div> : null}
        <div className="mt-12">
          <FilteredReviews />
        </div>
      </Section>

      <CtaBand title="Ook zo verhuizen?" />
    </>
  );
}
